<template>
  <div class="pricing-status">
    <div class="pricing-status__header">
      <b>Status:</b>
      <span
        class="pricing-status__label"
        :class="{
          'pricing-status__label_default': !hasCustomPrices,
          'pricing-status__label_custom': hasCustomPrices,
        }"
      >
        {{ hasCustomPrices ? 'Custom' : 'Default' }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DynamicPricingStatus',
  props: {
    hasCustomPrices: { type: Boolean, required: true },
  },
})
</script>
